import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { Injectable } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { SiteList, Site } from "../types/Site";
import { ProductActivity, SpecificProcess, FeedStocks } from "../types/FilterClasses";
import { Observable, of } from 'rxjs';
import { SiteProvince } from "src/app/common/model/shared.model";
import { Production } from "../types/Production";
import { SubRegion } from "../types/SubRegion";
import { CompanySite } from "../types/CompanySite";
import { SAPPlant } from "../types/SAPPlant";
import { LiquifierType } from "../types/LiquifierType";
import { LocalComapnyTypes, Franchise, IndustrialZone, PADDName } from "../types/Common";
import { ProductionVolumeUom } from "../types/ProductionVolumeUom";
import { SourceOfGas } from "../types/SourceOfGas";
import { Coordinates, GeocodeRequest, ReverseGeocode } from "../types/Location";
import { ProdGas, ProdVolHistory, ProdVolReason } from "../types/ProdVolHistory";
import { ProspectListItem } from "src/app/equipments/services/equipment.service";
import { PlantInfo } from "../types/PlantInfo";
import { TextDataResponse } from 'src/app/common/model/TextDataResponse';

@Injectable({
  providedIn: "any"
})
export class SiteService {

  constructor(protected http: HttpClient) {
  }

  baseurl = environment.apiBaseUrl;
  googlemapsUrl = environment.googlemapsUrl;

  getAllProductAcitivities(): Observable<ProductActivity[]> {
    return this.http.get<ProductActivity[]>(this.baseurl + 'Site/getallproductionactivities');
  }

  getAllSpecificProcess(): Observable<SpecificProcess[]> {
    return this.http.get<SpecificProcess[]>(this.baseurl + 'Site/getallspecificprocess');
  }

  getAllSites(filtercriteriaobj): Observable<TextDataResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<TextDataResponse>(this.baseurl + 'Site/sites', JSON.stringify(filtercriteriaobj, null, 2), httpOptions);
  }

  getSiteAndProvince(siteId: number) {
    return this.http.get<SiteProvince[]>(environment.apiBaseUrl + 'site/' + siteId + '/province');
  }

  GetPlantDetailsForSiteId(siteId: number): Observable<Site> {
    return this.http.get<Site>(environment.apiBaseUrl + 'site/' + siteId + '/details');
  }

  GetProductionDetailsForSiteId(siteId: number): Observable<Production> {
    return this.http.get<Production>(environment.apiBaseUrl + 'site/' + siteId + '/proddetails');
  }

  GetSubRegions(region): Observable<SubRegion[]> {
    region = encodeURIComponent(region);
    return this.http.get<SubRegion[]>(environment.apiBaseUrl + 'MasterData/getsubRegions/' + region);
  }

  GetAllCountries(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiBaseUrl + 'MasterData/getcountries');
  }

  GetAllProvinces(countryId: string): Observable<any[]> {
    return this.http.get<any[]>(environment.apiBaseUrl + `MasterData/getprovinces?countryId=${countryId}`);
  }

  GetAllCities(provinceId: string): Observable<any[]> {
    return this.http.get<any[]>(environment.apiBaseUrl + `MasterData/getcities?provinceId=${provinceId}`);
  }

  GetCompanyOwnersForSiteId(siteId): Observable<CompanySite[]> {
    return this.http.get<CompanySite[]>(environment.apiBaseUrl + 'Site/getcompanyowners/' + siteId);
  }

  GetSAPPlantList(): Observable<SAPPlant[]> {
    return this.http.get<SAPPlant[]>(environment.apiBaseUrl + 'Site/getsapplantlist');
  }

  GetLiquifierTypeList(): Observable<LiquifierType[]> {
    return this.http.get<LiquifierType[]>(environment.apiBaseUrl + 'Site/getallliquifiertypes');
  }

  GetAllLocalCompanyTypes(): Observable<LocalComapnyTypes[]> {
    return this.http.get<LocalComapnyTypes[]>(environment.apiBaseUrl + 'Site/getalllocalcompanytypes');
  }

  GetAllIndustrialZones(): Observable<IndustrialZone[]> {
    return this.http.get<IndustrialZone[]>(environment.apiBaseUrl + 'Site/getallindustrialzones');
  }

  GetAllFranchises(): Observable<Franchise[]> {
    return this.http.get<Franchise[]>(environment.apiBaseUrl + 'Site/getallfranchise');
  }

  GetAllPADDNames(): Observable<PADDName[]> {
    return this.http.get<PADDName[]>(environment.apiBaseUrl + 'Site/getallpaddnames');
  }

  SaveSite(plantInfo : PlantInfo): Observable<number> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<number>(this.baseurl + 'Site/updatesite', JSON.stringify(plantInfo, null, 2), httpOptions);
  }

  CheckSiteExists(plantInfo : PlantInfo): Observable<number> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<number>(this.baseurl + 'Site/IsSiteExist', JSON.stringify(plantInfo, null, 2), httpOptions);
  }

  SaveProduction(production : Production): Observable<Production> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<Production>(this.baseurl + 'Site/updateproduction', JSON.stringify(production, null, 2), httpOptions);
  }

  GetAllProdVolUOMList() : Observable<ProductionVolumeUom[]> {
    return this.http.get<ProductionVolumeUom[]>(environment.apiBaseUrl + 'Site/getprodvoluom');
  }

  GetAllSourceOfGasList() : Observable<SourceOfGas[]> {
    return this.http.get<SourceOfGas[]>(environment.apiBaseUrl + 'Site/getallsourceofgas');
  }

  GetSupplyTypes():Observable<ProspectListItem[]> {
    return this.http.get<ProspectListItem[]>(environment.apiBaseUrl + 'facility/supplytypes');
  }

  addNewSite(site : Site): Observable<Site> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<Site>(this.baseurl + 'Site/addsite', JSON.stringify(site, null, 2), httpOptions);
  }

  addNewProduction(production : Production): Observable<Production> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<Production>(this.baseurl + 'Site/addproduction', JSON.stringify(production, null, 2), httpOptions);
  }

  updateProdvolhistory(prodvolhistories : ProdVolHistory[]): Observable<ProdVolHistory[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<ProdVolHistory[]>(this.baseurl + 'Site/prodvolhistory', JSON.stringify(prodvolhistories, null, 2), httpOptions);
  }

  DeleteSite(siteId): Observable<number>{
    return this.http.delete<number>(environment.apiBaseUrl + 'Site/deletesiterecord/' + siteId);
  }

  getLatLong(geoRequest : GeocodeRequest) : Observable<Coordinates>{
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<Coordinates>(this.baseurl + 'Site/getLatLong', JSON.stringify(geoRequest, null, 2), httpOptions);
  }

  GetElevation(locations): Observable<string>{
    return this.http.get<string>(environment.apiBaseUrl + 'Site/getelevation/' + locations);
  }

  GetReverseGeocode(latlngStr : string): Observable<ReverseGeocode>{
    return this.http.get<ReverseGeocode>(environment.apiBaseUrl + 'Site/getreverseGeocoding/' + latlngStr + "/" + environment.gmaps);
  }

  getVolumesForSiteId(siteId) : Observable<ProdVolHistory[]> {
    return this.http.get<ProdVolHistory[]>(environment.apiBaseUrl + 'Site/getvolumesforsiteid/' + siteId);
  }

  GetAllGasProducts() : Observable<ProdGas[]> {
    return this.http.get<ProdGas[]>(environment.apiBaseUrl + 'Site/getallgasproducts');
  }

  GetAllReasons() : Observable<ProdVolReason[]> {
    return this.http.get<ProdVolReason[]>(environment.apiBaseUrl + 'Site/getallreasons');
  }

}
